import Link from "@mui/material/Link"
import TableCell from "@mui/material/TableCell"
import { format } from "date-fns"

import { adminApi } from "../axios"
import AdminHeaderTableCell, {
  AdminSortableHeaderCell,
  AdminTableHeadRow,
  adminTableBodyCellSx,
} from "../components/AdminHeaderTableCell"
import { dateRangeToParams } from "../components/AdminListToolbar"
import { AdminTableRow } from "../components/AdminListingTable"
import AdminRegistryListPage from "../components/AdminRegistryListPage"
import AdminTruncatedCell from "../components/AdminTruncatedCell"
import AdminVoicemailTranscriptCell from "../components/AdminVoicemailTranscriptCell"

export const VOICEMAIL_FILTER_SPECS = {
  concierge: { param: "concierge_user_id" },
  account: { param: "owner_user_id" },
  created: { toParams: dateRangeToParams("created") },
}

const TOOLBAR_FILTERS = [
  { key: "concierge", label: "Concierge", type: "entity", entity: "concierge" },
  {
    key: "account",
    label: "Parent account",
    type: "entity",
    entity: "account",
    placeholder: "Type 2+ letters",
  },
  { key: "created", label: "Received", type: "daterange" },
]

export default function AdminInboundVoicemail() {
  return (
    <AdminRegistryListPage
      title="Inbound voicemail"
      subtitle="Voicemails left on concierge Twilio DIDs."
      fetchFn={adminApi.fetchVoicemails}
      filterSpecs={VOICEMAIL_FILTER_SPECS}
      toolbarFilters={TOOLBAR_FILTERS}
      searchLabel="Search phone, transcript, concierge or owner"
      noun="voicemails"
      columnCount={7}
      tableHead={(query) => (
        <AdminTableHeadRow>
          <AdminSortableHeaderCell
            columnName="created"
            label="When"
            query={query}
            minWidth={{ xs: 72, sm: 88 }}
          />
          <AdminHeaderTableCell minWidth={{ xs: 88, sm: 112 }}>
            Concierge
          </AdminHeaderTableCell>
          <AdminHeaderTableCell minWidth={{ xs: 80, sm: 96 }}>
            Owner
          </AdminHeaderTableCell>
          <AdminHeaderTableCell minWidth={{ xs: 72, sm: 88 }}>
            From
          </AdminHeaderTableCell>
          <AdminHeaderTableCell minWidth={{ xs: 64, sm: 80 }}>
            DID
          </AdminHeaderTableCell>
          <AdminHeaderTableCell minWidth={{ xs: 120, sm: 160 }}>
            Transcript
          </AdminHeaderTableCell>
          <AdminHeaderTableCell minWidth={{ xs: 64, sm: 80 }}>
            Recording
          </AdminHeaderTableCell>
        </AdminTableHeadRow>
      )}
    >
      {(rows) =>
        rows.map((vm) => (
          <AdminTableRow key={vm.id} hover>
            <AdminTruncatedCell
              value={
                vm.created ? format(new Date(vm.created), "MMM d, h:mm a") : "—"
              }
            />
            <AdminTruncatedCell
              value={vm.concierge_name || vm.concierge_email}
            />
            <AdminTruncatedCell value={vm.owner_name || vm.owner_email} />
            <AdminTruncatedCell value={vm.from_phone} />
            <AdminTruncatedCell value={vm.did_phone} />
            <AdminVoicemailTranscriptCell
              transcript={vm.transcript}
              fromPhone={vm.from_phone}
              didPhone={vm.did_phone}
              created={
                vm.created
                  ? format(new Date(vm.created), "MMM d, yyyy h:mm a")
                  : undefined
              }
              conciergeName={vm.concierge_name || vm.concierge_email}
              ownerName={vm.owner_name || vm.owner_email}
            />
            <TableCell sx={adminTableBodyCellSx}>
              {vm.recording_url ? (
                <Link href={vm.recording_url} target="_blank" rel="noopener">
                  Play
                </Link>
              ) : (
                vm.recording_status || "—"
              )}
            </TableCell>
          </AdminTableRow>
        ))
      }
    </AdminRegistryListPage>
  )
}
